// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

/* eslint no-param-reassign: ["error", { "props": false }] */
import api from '@/api';
import session from '@/storage/session';

export default {
    createOrganization(form) {
        return api
            .post('/v1/organizations', form)
            .then((response) => {
                session.destroy('tenants');
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    updateOrganization(payload, id) {
        return api
            .post(`/v1/organizations/${id}`, payload)
            .then((response) => {
                session.destroy('tenants');
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    listPlaygroundPresets() {
        return api.get('/v1/organizations/playground/presets');
    },

    createPlayground(payload) {
        return api
            .post('/v1/organizations/playground', payload)
            .then((response) => {
                session.destroy('tenants');
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    regeneratePlayground(payload) {
        return api
            .post('/v1/organizations/playground/regenerate', payload)
            .then((response) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    playgroundStatus() {
        return api.get('/v1/organizations/playground/status');
    },

    fetchBatch(calls) {
        return api.batch(calls);
    },
};
